import { Injectable } from '@angular/core';
import { environment as env } from '../../environments/environment';
@Injectable()
export class APIURL {
	appVersion:string = env.appVersion;
	baseUrl:string = env.baseUrl;
	apiUrl: string = env.apiUrl;
	apiV3: string = env.apiV3;
	themeUrl: string =  env.themeUrl;
	themeUrlV3: string = env.themeUrlV3;
	transUrl: string = env.transUrl;
	imgBase: string = env.imgBase;
	assetsBase: string = env.assetsBase;
	domainName: string = env.domainName;
	fileCdn: string = env.fileCdn;
	bkcdn: string = env.bkcdn;
   invoiceUrl: string =  env.invoiceUrl;
	themeVersion : string = env.themeVersion;
	ejabDomain: string = env.ejabDomain;
}